import { CREATORBASE_ROOT_PATH } from 'Modules/Navigation/whitelabel/routes';

/**
 * Where the way back leads, both from the headline and from a request that can't be shown. Absolute,
 * like every other route in the app: react-router is on 6.3, which resolves a relative `..` against
 * the route tree rather than the path, and the detail route sits directly under pathless layout
 * routes — so `..` would land on `/`.
 */
export const OUTREACH_LIST_PATH = `/${CREATORBASE_ROOT_PATH}/outreach/`;

/** Names the way back wherever it is offered. */
export const BACK_TO_LIST_LABEL = 'Back to outreach requests';
